import { render, staticRenderFns } from "./TableFloatingFilter.vue?vue&type=template&id=95cca4c6&scoped=true&"
import script from "./TableFloatingFilter.vue?vue&type=script&lang=js&"
export * from "./TableFloatingFilter.vue?vue&type=script&lang=js&"
import style0 from "./TableFloatingFilter.vue?vue&type=style&index=0&id=95cca4c6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95cca4c6",
  null
  
)

export default component.exports